export default {

	props: {
		/**
		 * 类型
		 *
		 * pure: 纯色
		 * gradient: 渐变色
		 * border: 边框
		 * custom-toggle: 自定义切换
		 * custom-background: 自定义背景
		 */
		type: {
			type: String,
			default: 'pure'
		},

		/**
		 * 主题色
		 *
		 * 'pink' | 'blue' | 'orange' | 'green' | 'yellow' | 'purple'
		 */
		theme: {
			type: String,
			default: 'pink'
		},

		/** 是否为提交按钮 */
		is_submit: {
			type: Boolean,
			default: false
		},

		/** 是否为激活状态 */
		is_active: {
			type: Boolean,
			default: false
		},

		/** 宽度 */
		width: {
			type: String
		},

		/** 外边距 */
		margin: {
			type: String
		},

		/** 内边距 */
		padding: {
			type: String
		},

		/** 字体大小 */
		font_size: {
			type: String
		},

		/** 自定义背景图片
		 *
		 * ['normal_image_path', 'active_image_path']
		 */
		custom_background: {
			type: Array
		},
	},


	data() { return {
		button_is_active: this.is_active,
	}; },


	methods: {
		async update_button_is_active(value) {
			this.button_is_active = value;
		},
	},
};
